import ExceptionList from './ExceptionList'

ExceptionList.install = function (Vue) {
    Vue.component(ExceptionList.name, ExceptionList);
}

export default ExceptionList;